export default "/_next/static/assets/icons/apple/apple-touch-icon-180x180.b64e2d2224066e19d2393c749c6fae9b.png";